import { render, staticRenderFns } from "./ResponsableSection.vue?vue&type=template&id=df3f6390"
import script from "./ResponsableSection.vue?vue&type=script&lang=js"
export * from "./ResponsableSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports